import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEvent = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M2.016 1.75c0-.155.057-.303.16-.412.12-.129.336-.282.662-.421C3.332.707 3.964.583 4.75.583c.775 0 1.303.161 2.39.625.964.411 1.392.542 1.985.542.65 0 1.145-.096 1.506-.25.187-.08.278-.145.295-.162.344-.368.933-.108.933.412v7c0 .155-.057.303-.16.412-.12.129-.336.282-.662.421-.494.21-1.126.334-1.912.334-.775 0-1.303-.161-2.39-.625C5.77 8.88 5.342 8.75 4.75 8.75c-.65 0-1.145.096-1.506.25-.053.023-.098.044-.136.063l.001 3.77c0 .322-.244.584-.546.584-.303 0-.547-.262-.547-.584V1.75zm2.734 0c-.65 0-1.145.096-1.506.25-.052.022-.097.043-.135.063v5.752c.448-.148.993-.232 1.641-.232.775 0 1.303.161 2.39.625.964.411 1.392.542 1.985.542.65 0 1.145-.096 1.506-.25.052-.022.097-.043.135-.063V2.685c-.448.148-.993.232-1.641.232-.775 0-1.303-.161-2.39-.625C5.77 1.88 5.342 1.75 4.75 1.75z"
	})
});
export default SvgEvent;
